import { PICTREE } from "../../constants";
import moment from "moment-timezone";

export const SAITAMA_SEASON = {
  seasonId: "cmuj8rted00010lnwciotguzf",
  seasonName: "さいたま市みんなのフォトハント〜商店街の街路灯を撮影せよ！〜",
  displayName: "さいたま市シーズン",
  seasonStart: "2026-10-09",
  seasonEnd: "2026-11-04",
  seasonStartUtc: "2026-10-09T00:00:00.000Z",
  seasonEndUtc: "2026-11-04T08:00:00.000Z",
};

export const getSaitamaToday = (now = new Date()) =>
  moment(now).tz("Asia/Tokyo").format("YYYY-MM-DD");

export const getSaitamaLatestSelectableDate = (season = SAITAMA_SEASON, now = new Date()) =>
  moment.min(
    moment.tz(getSaitamaToday(now), "YYYY-MM-DD", "Asia/Tokyo"),
    moment.tz(season.seasonEnd, "YYYY-MM-DD", "Asia/Tokyo")
  ).format("YYYY-MM-DD");

export const getSaitamaDefaultDateRange = (season = SAITAMA_SEASON, now = new Date()) => [
  season.seasonStart,
  getSaitamaLatestSelectableDate(season, now),
];

const initialState = {
  selectedSeason: [SAITAMA_SEASON],
  seasonData: [SAITAMA_SEASON],
  dateRange: getSaitamaDefaultDateRange(),
  chartSize: "day",
  overview: {
    status: "idle",
    error: null,
    homeDataPhotoShoot: {
      countPic: undefined,
      countAsset: undefined,
      countReviewOk: undefined,
      countDenchu: undefined,
      countUniqueUser: undefined,
      progressDenchu: { taken: undefined, max: undefined },
    },
    photoShootTrend: [],
  },
  reportOverview: {
    status: "idle",
    error: null,
    totalReportCount: undefined,
    totalReporterCount: undefined,
    tagAssignmentCount: undefined,
    reportStats: [],
    reportTrend: [],
    tagOrder: [],
  },
};

export default function pictreeSaitamaReducer(state = initialState, action) {
  switch (action.type) {
    case PICTREE.SET_SAITAMA_SEASON:
      return { ...state, selectedSeason: action.payload };
    case PICTREE.SET_SAITAMA_DATE_RANGE:
      return { ...state, dateRange: action.payload };
    case PICTREE.SET_SAITAMA_CHART_SIZE:
      return { ...state, chartSize: action.payload };
    case PICTREE.GET_SAITAMA_OVERVIEW:
      return { ...state, overview: { ...state.overview, status: "loading", error: null } };
    case PICTREE.SET_SAITAMA_OVERVIEW:
      return { ...state, overview: { ...state.overview, ...action.payload, status: "ready" } };
    case PICTREE.GET_SAITAMA_REPORT_OVERVIEW:
      return { ...state, reportOverview: { ...state.reportOverview, status: "loading", error: null } };
    case PICTREE.SET_SAITAMA_REPORT_OVERVIEW:
      return { ...state, reportOverview: { ...state.reportOverview, ...action.payload, status: "ready" } };
    default:
      return state;
  }
}
